import { useContext } from 'react';
import { NavigationContext } from './NavigationHeightContext';

const useNavigationHeight = () => {
  const { navHeight, forceRecalculate, navHeightRef } = useContext(NavigationContext) ?? {};

  return { navHeight, forceRecalculate, navHeightRef };
};

export default useNavigationHeight;
